import React, { useState } from 'react';
import axios from 'axios';

const CreateNewEmployeePage = () => {
  console.log("✅ CreateNewEmployeePage component rendering...");

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    city: '',
    state: '',
    password: '',
  });
  console.log("🔹 Initial formData state:", formData);

  const [message, setMessage] = useState('');
  console.log("🔹 Initial message state:", message);

  const apiBaseURL = process.env.REACT_APP_API_BASE_URL;
  console.log("🔹 API Base URL:", apiBaseURL);

  const handleChange = (e) => {
    console.log(`📝 Input changed — Field: ${e.target.name}, Value: ${e.target.value}`);
    setFormData(prev => {
      const updatedFormData = { ...prev, [e.target.name]: e.target.value };
      console.log("🆙 Updated formData:", updatedFormData);
      return updatedFormData;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("📤 Form submitted!");

    const apiURL = `${apiBaseURL}/api/employees/create-new-employee`;
    console.log("🌐 API Request URL:", apiURL);
    console.log("📦 API Request Payload:", formData);

    try {
      const response = await axios.post(apiURL, formData);
      console.log("✅ API Response:", response.data);

      setMessage(response.data.message);
      console.log("🔔 Message updated:", response.data.message);

      setFormData({ name: '', email: '', phone: '', city: '', state: '', password: '' });
      console.log("🧹 formData state reset to empty.");

    } catch (err) {
      console.error("❌ Error during employee creation:", err);
      setMessage('Failed to create employee.');
      console.log("🔔 Message updated: Failed to create employee.");
    }
  };

  return (
    <div className="p-6" style={{ marginLeft: '16rem' }}>
      <h2 className="text-2xl font-semibold mb-4">Create New Employee</h2>
      <form onSubmit={handleSubmit} className="space-y-4 max-w-md">
        {['name', 'email', 'phone', 'city', 'state', 'password'].map(field => (
          <div key={field}>
            <label className="block capitalize mb-1">{field}</label>
            <input
              type={field === 'password' ? 'password' : 'text'}
              name={field}
              value={formData[field]}
              onChange={handleChange}
              required
              className="w-full border p-2 rounded"
            />
          </div>
        ))}
        <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded">Create</button>
      </form>
      {message && (
        <p className="mt-4">{message}</p>
      )}
    </div>
  );
};

export default CreateNewEmployeePage;
